import { Link } from 'react-router'
import MoreVert from '@mui/icons-material/MoreVert'
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material'
import useOverlay from '@/hooks/useOverlay'
import { SUPER_USER_ONLY_COLOR } from '@/theme/usePixydocsTheme'
import { showInfoSnackbar } from '@/utils/snackbars'
import { useCurrentAccountContext } from '../accounts/CurrentAccountProvider'
import copyToClipboard from '../document-actions-menu/copy-to-clipboard'

export default function SuperUserMenu() {
  const overlay = useOverlay()
  const { currentAccount } = useCurrentAccountContext()

  return (
    <div>
      <Tooltip title="Super User Menu">
        <IconButton
          onClick={overlay.toggle}
          size="small"
          id="super-user-button"
          sx={{ color: SUPER_USER_ONLY_COLOR }}
        >
          <MoreVert />
        </IconButton>
      </Tooltip>

      <Menu
        id="super-user-menu"
        anchorEl={overlay.anchorEl as Element}
        open={overlay.isOpen}
        onClose={overlay.close}
        slotProps={{
          list: {
            'aria-labelledby': 'super-user-button',
          },
        }}
      >
        <MenuItem
          onClick={() => {
            copyToClipboard(currentAccount.id)
            showInfoSnackbar('Copied to Clipboard')
            overlay.close()
          }}
        >
          Copy Account ID
        </MenuItem>
        <MenuItem component={Link} to="/in-flight-docs" onClick={overlay.close}>
          In-Flight Documents
        </MenuItem>
        <MenuItem
          component={Link}
          to="/zerapix-management/accounts"
          onClick={overlay.close}
        >
          Accounts
        </MenuItem>
        <MenuItem
          component={Link}
          to="/zerapix-management/customers"
          onClick={overlay.close}
        >
          Customers
        </MenuItem>
        <MenuItem
          component={Link}
          to="/zerapix-management/feature-flags"
          onClick={overlay.close}
        >
          Feature Flags
        </MenuItem>
        <MenuItem
          component={Link}
          to="/total-documents"
          onClick={overlay.close}
        >
          Document Counts
        </MenuItem>
      </Menu>
    </div>
  )
}
